export default __webpack_public_path__ + "static/media/crown.929c9dad.png";